// Liste des prestataires sushi en place (utilisée comme concurrent pour les campagnes)
export const PRESTATAIRES = [
  'Aucun',
  'White Space',
  'Sushiman',
  'Hanagroup',
  'KD',
  'Papylee',
  'Côté Sushi',
  'Sushishop',
  'Maki Chef',
  'Katana',
  'Yumi Sushi',
  'Bento Sushi',
  'Maitre Cooken',
  'Autre',
];
